import { activitiesConstants } from "@data/constants/activitiesConstants"
import { activitiesService } from "@data/services/activitiesService"
import { authService } from "@data/services/authService"
import { apiConstants } from "@data/constants/apiConstants"

const initialState = {
    activity: null,
}

export default function currentActivity(state = initialState, action) {
    switch (action.type) {
        case activitiesConstants.SET_CURRENT_ACTIVITY:
            return {
                ...state,
                activity: action?.data,
            }
        case activitiesService.getActivities.name + apiConstants._SUCCESS: {
            // Update current activity if it's in the response
            const updatedActivity = action.data?.find(
                (a) => a?.id === state.activity?.activityData?.id
            )
            if (updatedActivity) {
                return {
                    ...state,
                    activity: {
                        ...state.activity,
                        activityData: updatedActivity,
                    },
                }
            }
            return state
        }
        case authService.getUser.name + apiConstants._SUCCESS: {
            // Sync current activity when user data refreshes (e.g. tutor edited title)
            if (!state.activity?.activityData?.id) return state
            const id = state.activity.activityData.id
            const fresh =
                action.data?.todo_activities?.find((a) => a?.id === id) ??
                action.data?.activities?.find((a) => a?.id === id)
            if (fresh) {
                return {
                    ...state,
                    activity: {
                        ...state.activity,
                        activityData: {
                            ...state.activity?.activityData,
                            ...fresh,
                        },
                    },
                }
            }
            return state
        }
        default:
            return state
    }
}
